import { DeviationResourceType, DeviationTypes } from '../../types/deviation';
import { CommentableTypes } from '../../Comment/redux/types';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { DeviationViewMode } from '@wix/da-react-context/pkg/SessionContext';
import { GruserType } from '@wix/da-gruser-shared/pkg/types/';
import { getDeviationTitle, getDeviationType, getRelatedContentBlock } from '../../DeviationViews/_helpers';
import get from 'lodash/get';
import { getDeviationEntityId } from '../../redux/normalizr/schemas/deviation';
export function getCommentableTypeForDeviationType(deviationTypeId) {
    switch(deviationTypeId){
        case DeviationResourceType.COMMISSION:
            return CommentableTypes.COMMENT_COMMISSION;
        case DeviationResourceType.POLL:
            return CommentableTypes.COMMENT_POLL_BLOG;
        case DeviationResourceType.STATUS:
            return CommentableTypes.COMMENT_STATUS;
        case DeviationResourceType.ART:
        case DeviationResourceType.JOURNAL:
        default:
            return CommentableTypes.COMMENT_DEVIATION;
    }
}
export function getDeviationTypeForCommentableType(commentableTypeId) {
    switch(commentableTypeId){
        case CommentableTypes.COMMENT_COMMISSION:
            return DeviationResourceType.COMMISSION;
        case CommentableTypes.COMMENT_POLL_BLOG:
            return DeviationResourceType.POLL;
        case CommentableTypes.COMMENT_STATUS:
            return DeviationResourceType.STATUS;
        case CommentableTypes.COMMENT_DEVIATION:
            return DeviationResourceType.ART;
        default:
            return DeviationResourceType.UNKNOWN;
    }
}
export function getBiEventTypeForViewChange(currentViewMode, nextViewMode) {
    switch(nextViewMode){
        case DeviationViewMode.Fullscreen:
            return BiEventType.FULLSCREEN_MODE;
        case DeviationViewMode.Theater:
            return BiEventType.THEATRE_MODE;
        default:
            if (currentViewMode === DeviationViewMode.Fullscreen) {
                return BiEventType.FULLSCREEN_MODE;
            } else {
                return BiEventType.THEATRE_MODE;
            }
    }
}
export function getBiEventComponentByType(deviationType) {
    switch(deviationType){
        case DeviationTypes.COMMISSION:
            return 'commission';
        case DeviationTypes.STATUS:
            return 'status';
        case DeviationTypes.POLL:
            return 'poll';
        case DeviationTypes.JOURNAL:
            return 'journal';
        case DeviationTypes.TIER:
            return 'tier';
        default:
            return 'art';
    }
}
export function getPageTitle(deviation, t) {
    if (!deviation) {
        return t('deviation.page.title.unknown');
    }
    const deviationTitle = getDeviationTitle(deviation);
    const { author } = deviation;
    const isStatus = getDeviationType(deviation) === DeviationTypes.STATUS;
    if (!author || !isStatus && !deviationTitle) {
        return t('deviation.page.title.unknown');
    }
    if (isStatus) {
        return t('deviation.page.title.status', {
            author: author.username
        });
    }
    return t('deviation.page.title', {
        author: author.username,
        title: deviationTitle
    });
}
export function getDeviationNotificationQueue({ deviationId, typeId }) {
    return `deviation-${typeId}-${deviationId}`;
}
export function isExtendedDeviationFullyLoaded(deviation) {
    return !!((deviation === null || deviation === void 0 ? void 0 : deviation.extended) && get(deviation, 'extended.isComplete', true));
}
export function getDeviationAppUrl(deviation) {
    var _deviation_extended;
    const uuid = deviation === null || deviation === void 0 ? void 0 : (_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.deviationUuid;
    if (!uuid) {
        return;
    }
    switch(getDeviationType(deviation)){
        // special snowflake
        case DeviationTypes.STATUS:
            return `status/${uuid}`;
        // unsupported types
        case DeviationTypes.COMMISSION:
        case DeviationTypes.POLL:
        case DeviationTypes.UNKNOWN:
            return;
        default:
            return `deviation/${uuid}`;
    }
}
export function getGruserForDeviation(deviation) {
    var _deviation_author;
    return {
        gruserId: ((_deviation_author = deviation.author) === null || _deviation_author === void 0 ? void 0 : _deviation_author.userId) || 0,
        gruserTypeid: GruserType.Deviation,
        gruserItemid: deviation.deviationId
    };
}
export function getGruserOwnerForDeviation(deviation) {
    return deviation.author;
}
export function getDefaultDuperbrowseStream(deviation, referrer) {
    var _getDefaultStreamFromDeviation;
    const itemId = getDeviationEntityId(deviation);
    if (!itemId) {
        return;
    }
    var _getDefaultStreamFromDeviation_deviations;
    const defaultStreamItems = (_getDefaultStreamFromDeviation_deviations = (_getDefaultStreamFromDeviation = getDefaultStreamFromDeviation(deviation, referrer)) === null || _getDefaultStreamFromDeviation === void 0 ? void 0 : _getDefaultStreamFromDeviation.deviations) !== null && _getDefaultStreamFromDeviation_deviations !== void 0 ? _getDefaultStreamFromDeviation_deviations : [];
    const streamItems = [
        deviation,
        ...defaultStreamItems
    ];
    return {
        streamId: `devpage-rootstream-${itemId}`,
        currentOpenItem: itemId,
        items: streamItems.map((d)=>getDeviationEntityId(d)).filter(function(value, index, array) {
            return array.indexOf(value) === index;
        }),
        itemSchema: 'deviation'
    };
}
function getDefaultStreamFromDeviation(deviation, referrer) {
    var _deviation_extended;
    if (deviation === null || deviation === void 0 ? void 0 : (_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.relatedContent) {
        const filteredRelated = deviation.extended.relatedContent.filter((block)=>{
            // Must be deviations block and not something like a single tier
            return Array.isArray(block.deviations) && block.deviations.length > 1;
        });
        if (filteredRelated.length === 0) {
            return getRelatedContentBlock(deviation, 'recommended');
        }
        return filteredRelated[0];
    }
    switch(getDeviationType(deviation)){
        case DeviationTypes.STATUS:
            return getRelatedContentBlock(deviation, 'latest_status');
        case DeviationTypes.POLL:
            return getRelatedContentBlock(deviation, 'more_polls');
        case DeviationTypes.JOURNAL:
            return getRelatedContentBlock(deviation, 'more_journals');
        case DeviationTypes.LITERATURE:
            return getRelatedContentBlock(deviation, 'recommended_literature') || getRelatedContentBlock(deviation, 'recommended');
        default:
            return getRelatedContentBlock(deviation, 'recommended');
    }
}
